const tripDetails = {
    tripNotFound: 'Viaggio Non Trovato',
    tripNotFoundDescription: 'Il viaggio che stai cercando non esiste.',
    backToHome: 'Torna alla Home',
    overview: 'Panoramica',
    itinerary: 'Itinerario',
    faqs: 'FAQ',
    searchFaqs: 'Cerca nelle domande e risposte...',
    searchResults: 'Trovate {count} domande per "{term}"',
    noSearchResults: 'Nessun risultato trovato per "{term}"',
    map: 'Mappa',
    bookThisTrip: 'Prenota questo viaggio',
    expandAll: 'Espandi tutto',
    whatDoWeDo: 'Cosa facciamo',
    day: 'Giorno',
    sendEnquiry: 'Invia Richiesta',
    tripName: 'Nome viaggio: *',
    enterYourName: 'Inserisci il tuo nome *',
    enterYourEmail: 'Inserisci la tua email *',
    chooseCountry: 'Scegli un paese *',
    selectCountry: 'Seleziona un paese',
    enterContactNumber: 'Inserisci il tuo numero di telefono *',
    directions: 'Indicazioni',
    viewLargerMap: 'Visualizza mappa più grande',
    interactiveGoogleMap: 'Mappa Google Interattiva',
    googleMapFor: 'Mappa Google per',
    edit: 'Modifica',
    location: 'Posizione',
    only: 'Solo',
    days: 'Giorni',
    nights: 'Notti',
    doYouWantToBook: 'Vuoi prenotare questo viaggio?',
    sendUsMessage: 'Inviaci un messaggio tramite il modulo',
    availableDates: 'Date Disponibili',
    breadcrumbTrips: 'Viaggi',
    breadcrumbProducts: 'Prodotti',
    youCanSendEnquiry: 'Puoi inviare la tua richiesta tramite il modulo qui sotto.',
    countryItaly: 'Italia',
    countryGermany: 'Germania',
    countryFrance: 'Francia',
    countrySpain: 'Spagna',
    reviews: 'recensioni'
};

export default tripDetails;
